var MuiIconButton = {
    /* put your new default props here */
    color: 'primary',
};
export default MuiIconButton;
//# sourceMappingURL=MuiIconButton.js.map